import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Modal from './Modal';

/**
 * MultiStepModal component
 * Renders a modal with a multi-step form
 */
function MultiStepModal({
  id,
  title,
  steps,
  isOpen,
  canProceed,
  onConfirm,
  onClose,
  onNext,
  onPrevious,
  currentStep,
  isConfirmPending,
  isDisabledEscape,
}) {
  const isLastStep = currentStep === steps.length - 1;
  const intl = useIntl();

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onPreviousButtonClick={currentStep > 0 ? onPrevious : onClose}
      onNextButtonClick={isLastStep ? onConfirm : onNext}
      previousButtonLabel={
        currentStep > 0
          ? intl.formatMessage({ defaultMessage: 'Back', id: '0557f' })
          : intl.formatMessage({ defaultMessage: 'Cancel', id: 'ea478' })
      }
      nextButtonLabel={
        isLastStep
          ? intl.formatMessage({ defaultMessage: 'Apply', id: '9639e' })
          : intl.formatMessage({ defaultMessage: 'Next', id: '10ac3' })
      }
      isDisabledEscape={isDisabledEscape}
      isDisabledPreviousButton={isDisabledEscape}
      isDisabledNextButton={!canProceed}
      onClose={onClose}
      title={title}
      isConfirmPending={isConfirmPending}
    >
      {steps[currentStep]}
    </Modal>
  );
}

MultiStepModal.propTypes = {
  canProceed: PropTypes.bool.isRequired,
  currentStep: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  isConfirmPending: PropTypes.bool,
  isDisabledEscape: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.node).isRequired,
  title: PropTypes.string.isRequired,
};

MultiStepModal.defaultProps = {
  isConfirmPending: false,
  isDisabledEscape: false,
};

export default MultiStepModal;
